import React, { FC } from 'react';
import { Skeleton } from '@mofid-securities/uikit';
import { Icon } from '@/components/atomic/Icon';
import { IBalanceSlideSubComponentProps } from '../../BalanceSlide.types';

interface IHamiBalanceSlideTitleProps extends IBalanceSlideSubComponentProps {}

const HamiBalanceSlideTitle: FC<IHamiBalanceSlideTitleProps> = ({
  isError,
  isLoading,
}) => (
  <>
    {isLoading ? (
      <Skeleton className="!h-4 !w-[105.16px] md:!h-7 md:!w-[120.19]" />
    ) : isError ? (
      <div className="flex items-center justify-center gap-[4px] text-warning">
        <Icon icon="info_outline" size={15} />
        <span className="text-sm !font-demibold">خطا در دریافت اطلاعات</span>
      </div>
    ) : (
      'موجودی پس‌انداز:'
    )}
  </>
);
export default HamiBalanceSlideTitle;
